import PythonRunner from './PythonRunner';
import './App.css';
import { useState } from 'react';
import ProjectLoader from './ProjectLoader';
import { Col, Container, Row } from 'react-bootstrap';

const App = () => {
  
  const [project, setProject] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="App">
    <Container fluid style={{maxWidth: "1320px"}}>
      <Row className="p-5 justify-content-center" >
        <Col md={4} className="text-center">
          <ProjectLoader setProject={setProject} isLoading={isLoading}/>
          <hr/>
        </Col>
        <Col md={8} className="text-center">
          {project &&
          <PythonRunner 
          entryScript={project.entryScript} 
          workingDirectory={project.workingDirectory} 
          deps={project.deps} 
          otherScripts={project.otherScripts}
          artifacts={project.artifacts}
          ignoreWarnings={project.ignoreWarnings}
          setGlobalLoading={setIsLoading}
          />
          }
        </Col>
      </Row>
    </Container>
    </div>
  );
}

export default App;